import { ACTIVITY_WINDOW_TYPE, GAME_ID, LEVEL_STAGE } from '../data/constants';

const initialState = {
  dataLoaded: false,
  // Landing page is ProgressView
  windowType: ACTIVITY_WINDOW_TYPE.PROGRESS,
  // Default is STANDARD because it's the safest entry
  // (there should always be data)
  stage: LEVEL_STAGE.STANDARD,
  // Default is 0 because 0 is the OnboardingItem
  level: 0,
  isLevelButtonClicked: false,
};

/**
 * These are all super self-explanatory
 *
 * Quick Refs:
 * SET_REPORTER
 * SET_WINDOW_TYPE
 * SET_LEVEL_STAGE
 * SET_LEVEL
 * INCREMENT_LEVEL
 * SET_BACK_BUTTON
 */
const stagingReducer = (state = initialState, action) => {
  if (action.gameId !== GAME_ID) {
    return state;
  }

  switch (action.type) {
    case 'LOAD_NEW_LEVEL':
      return {
        ...state,
        stage: LEVEL_STAGE.STANDARD,
        level: action.level,
        isLevelButtonClicked: false,
      };
    case 'CLEAR_DATA_LOADED':
      return {
        ...state,
        dataLoaded: false,
      };
    case 'SET_WINDOW_TYPE':
      return {
        ...state,
        windowType: action.windowType,
      };
    case 'SET_LEVEL_STAGE':
      return {
        ...state,
        stage: action.levelStage,
      };
    case 'SET_LEVEL':
      return {
        ...state,
        level: action.level,
      };
    case 'INCREMENT_LEVEL':
      return {
        ...state,
        level: state.level + 1,
      };
    case 'SET_LEVEL_BUTTON_CLICKED':
      return {
        ...state,
        isLevelButtonClicked: action.payload,
      };
    default:
      return state;
  }
};

export default stagingReducer;
